<template>
    <el-select filterable class="span_12 h-4" v-model="tmpCountryCode" v-on:change="change">
        <el-option v-for="item in countries" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
    </el-select>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
export default {
    props: {
        defaultValue: {
            type: Object,
            required: false,
            default: {
                code: '',
                name: '',
            },
        },
    },
    computed: {
        ...mapStateUser(['locale', 'uiLang']),
    },
    methods: {
        change(code) {
            this.value = this.countries.reduce((previous, current) => {
                return current.code == code ? current : previous;
            }, null);

            this.$emit('change', this.value);
        },
    },
    data() {
        return {
            value: this.defaultValue,
            countries: [],
            tmpCountryCode:
                this.defaultValue.code === 'en' ? 'GB' : this.defaultValue.code.toUpperCase(),
            tmpCountryName: this.defaultValue.name,
        };
    },
    mounted() {
        this.$ajax.get(`/rest/countries`, { lang: this.uiLang }, (response) => {
            let emited = false;
            this.countries = Object.values(response.countries)
                .filter((item) => {
                    return item.code;
                })
                .sort((a, b) => {
                    return b.shortlist - a.shortlist;
                })
                .map((item) => {
                    if (this.value.code == '' && item.selected == 'Y') {
                        this.value.code = item.code;
                        this.value.name = item.name;
                        this.tmpCountryCode = item.code;
                        this.tmpCountryName = item.name;
                        this.$emit('change', this.value);
                        emited = true;
                    }
                    return item;
                });
            if (!emited) {
                this.value = { code: this.tmpCountryCode, name: this.tmpCountryName };
                this.$emit('change', this.value);
            }
        });
    },
};
</script>
